import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { DckActionCreators, DckSelectors } from "dck-redux"

import * as ItemTypes from "../../redux/items/types"
import LoanForm from "./Form"
import { changeLoanStatus, resubmitLoan } from "../../redux/actions/loans"
import { browserHistory } from "react-router"
import { LoanStatus } from "../../lib/utils"
import { loadLoanDetails } from "../../redux/actions/loans"
import processTypes from "../../redux/processes/types"
import Authenticated from "../../lib/Authenticated"
import { Alert } from "react-bootstrap"
import FontAwesome from "react-fontawesome"

class DetailLoan extends Component {

  authenticated = new Authenticated()
  isApprover = this.authenticated.isApprover()
  isUnderwriter = this.authenticated.isUnderwriter()
  isAdmin = this.authenticated.isAdmin()
  isAccountant = this.authenticated.isAccountant()
  isPaymentManager = this.authenticated.isPaymentManager()
  isImpersonation = this.authenticated.isImpersonation()
  userCanOpenDevice = this.authenticated.canOpenDevice()

  componentDidMount() {

    const { params: { id }, loadLoanCommissions, reloadLoan } = this.props
    loadLoanCommissions()
    reloadLoan(id)
  }

  assignLoanClick = (id, status) => {

    const newStatus = ((this.isAdmin && status === LoanStatus.NEW) || this.isUnderwriter) 
      ? LoanStatus.UNDERWRITER_REVIEW : LoanStatus.APPROVER_REVIEW

    this.props.setLoanStatus(id, newStatus)
  }

  approveLoanClick = (id, status) => {

    const newStatus = ((this.isAdmin && status === LoanStatus.UNDERWRITER_REVIEW) || this.isUnderwriter)
      ? LoanStatus.UNDERWRITER_APPROVED : LoanStatus.APPROVED

    this.props.setLoanStatus(id, newStatus)

    if(!this.isAdmin) {
      browserHistory.push("/loans")
    }
  }

  declineLoanClick = (id, status) => {

    const newStatus = ((this.isAdmin && status === LoanStatus.UNDERWRITER_REVIEW) || this.isUnderwriter) 
      ? LoanStatus.UNDERWRITER_DECLINED : LoanStatus.DECLINED

    this.props.setLoanStatus(id, newStatus)

    if(!this.isAdmin) {
      browserHistory.push("/loans")
    }
  }

  resubmitDeclineLoanClick = (id, status) => this.props.resubmitDeclinedLoan(id, status)

  renderStatuses = (reloadRunning, reloadError) => (
    reloadRunning ? <p><FontAwesome name='clock-o'/> Running ..</p>
    : reloadError ? <Alert bsStyle="warning">
        <FontAwesome name='exclamation-circle'/> { reloadError }
      </Alert>
    : null
  )

  render() {

    const { currentLoan, loadLoanDetails, loanDetails, detailsRunning,
      detailsFailed, loanCommissions, setLoan, reloadLoan, reloadRunning, reloadError } = this.props

    if(!currentLoan) return this.renderStatuses(reloadRunning, reloadError)
    return (
      <LoanForm
        loan={ currentLoan }
        assignLoanClick={ this.assignLoanClick }
        approveLoanClick={ this.approveLoanClick }
        declineLoanClick={ this.declineLoanClick }
        resubmitDeclineLoanClick={ this.resubmitDeclineLoanClick }
        loadLoanDetails={ loadLoanDetails }
        loanDetails={ loanDetails }
        isApprover={ this.isApprover }
        isUnderwriter={ this.isUnderwriter }
        isAdmin={ this.isAdmin }
        isAccountant={ this.isAccountant }
        isImpersonation={ this.isImpersonation }
        isPaymentManager={ this.isPaymentManager }
        detailsRunning={ detailsRunning }
        detailsFailed={ detailsFailed }
        loanCommissions={ loanCommissions }
        setLoan={ setLoan }
        reloadLoan={ reloadLoan }
        userCanOpenDevice={ this.userCanOpenDevice }
      />
    )
  }
}

DetailLoan.propTypes = {
  currentLoan: PropTypes.object,
  params: PropTypes.object.isRequired,
}

const mapStateToProps = (state, { params: { id: loanId }}) => {

  const pagedLoans = DckSelectors.selectAllItems(state, ItemTypes.Loan),

  currentLoan = pagedLoans.content
    ? pagedLoans.content.find(item => item.id === loanId)
    : undefined,

  detailsRunning = DckSelectors.selectProcessRunning(
    state,
    processTypes.LOAD_LOAN_DETAILS_PROCESS
  ),

  detailsFailed = DckSelectors.selectProcessFailed(
    state,
    processTypes.LOAD_LOAN_DETAILS_PROCESS
  ),

  reloadRunning = DckSelectors.selectProcessRunning(
    state,
    processTypes.RELOAD_LOAN_PROCESS
  ),

  reloadResult = DckSelectors.selectProcess(
    state,
    processTypes.RELOAD_LOAN_PROCESS
  ),

  reloadError = (reloadResult && reloadResult.result) ? reloadResult.result.text : null,

  loanCommissions = DckSelectors.selectAllItems(state, ItemTypes.LoanCommission)

  let loanDetails = DckSelectors.selectItemById(state, ItemTypes.LoanDetails, loanId)
  loanDetails = loanDetails ? loanDetails.data : null

  return { currentLoan, loanDetails, detailsRunning, detailsFailed,
    loanCommissions, reloadRunning, reloadError }
},

mapDispatchToProps = dispatch => ({

  setLoanStatus: (id, status) => dispatch(changeLoanStatus(id, status)),

  resubmitDeclinedLoan: (id, status) => dispatch(resubmitLoan(id, status)),

  loadLoanDetails: loanId => dispatch(loadLoanDetails(loanId)),

  loadLoanCommissions: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.LoanCommission)),

  setLoan: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.Loan, id, data)),

  reloadLoan: id => dispatch(DckActionCreators.itemReload(ItemTypes.Loan, id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailLoan)



// WEBPACK FOOTER //
// ./src/components/Loans/Detail.js